import React from 'react';

// Only allow iframing LinkedIn's own embed endpoint. Storing (and validating) a
// URL rather than a raw <iframe> keeps the rich-text renderer free of arbitrary
// HTML, so no sanitization is needed.
const ALLOWED_HOSTS = ['www.linkedin.com', 'linkedin.com'];

export function getSafeLinkedInEmbedUrl(value: string): string | null {
  try {
    const url = new URL(value.trim());
    if (url.protocol !== 'https:') return null;
    if (!ALLOWED_HOSTS.includes(url.hostname)) return null;
    if (!url.pathname.startsWith('/embed/')) return null;
    return url.toString();
  } catch {
    return null;
  }
}

interface LinkedInEmbedProps {
  /**
   * Full LinkedIn embed URL, e.g.
   * https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:1234567890
   */
  url: string;
}

/** Embeds a LinkedIn post. Renders nothing if the URL isn't a trusted embed URL. */
export const LinkedInEmbed = ({ url }: LinkedInEmbedProps) => {
  const safeUrl = getSafeLinkedInEmbedUrl(url);
  if (!safeUrl) return null;

  return (
    <iframe
      className="mx-auto my-4 block h-[500px] w-full max-w-[552px] border-0"
      src={safeUrl}
      title="Embedded LinkedIn post"
      loading="lazy"
    />
  );
};
